<template>
	<div>
		<TableList v-bind="getData" @on-radio-change="checkChange"></TableList>
		<div class="text-right">
			<vButton @click="click" theme="primary">{{$t('global.common.update_OK',{defaultValue:'确定'})}}</vButton>
			<vButton class="margin-left-10" @click="cancel" >{{$t('global.common.operation_cancel',{defaultValue:'取消'})}}</vButton>
		</div>
	</div>
</template>
<script>
import { HttpB2cList } from "@/service/boss/b2corder";
import TableList from "@components/templates/tablelist"
export default {
	props:['products','initFormData'],
	components: {
		TableList
	},
	methods: {
		checkChange(rows, val) {
			// console.log(rows)
			this.rows = rows
		},
		click() {
			this.$emit('rows', this.rows)
		},
		cancel(){
			this.$emit('cancel')
		},
	},
	computed: {
		getData() {
			return {
				initFormData: {
					search:{
						'EQ_orderNo':0
					}
				},
				ajaxRequest: HttpB2cList,
				startUp: true,
				Searchs: {
					show: true,
					style: "border:none;",
					// labelWidth: 'auto',
					align: "left"
				},
				SearchsData: [{
					label: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
					tag: 'vInput',
                    key: 'EQ_orderNo',
                    style:"width:250px",
					show: true,
				}],
				columns: [{
					type: 'selection',
					width: 50,
					align: "center",
					formName: 'id',
					isRadio:true,
				}, {
					title: "ID",
                    key: 'id',
                    width:90,
				}, {
					title: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
					key: 'orderNo'
				}, {
					title: this.$t('erp.b2c.channel_account',{defaultValue:'渠道账号'}),
					key: 'channelFlag',
                },
                {
					title: this.$t('global.common.project',{defaultValue:'项目'}),
                    key: 'lineId',
                    render:(h,{row})=>{
                        const id = row.lineId;
                        const product = this.products.filter((item) => {
                            return id == item.value
                        })[0] || {};
                        return <div>{product.label||'-'}</div>
                    }
                },
                {
                    title: this.$t('erp.b2c.search_ordertype',{defaultValue:'订单类型'}),
                    width:110,
                    // key: 'orderType',
                    render:(h,{row})=>{
                        let ordertype;
                        switch (row.orderType) {
                            case 'normally': ordertype = <div class="b2ccolor-dark-primary font-weight span-padding">{this.$t('erp.b2c.ordertype_normally',{defaultValue:'正常销售'})}</div>; break;
                            case 'celebrity': ordertype = <div class="b2ccolor-error font-weight span-padding">{this.$t('erp.b2c.ordertype_celebrity',{defaultValue:'展示订单'})}</div>; break;
                            case 'distribution': ordertype = <div class="b2ccolor-success font-weight span-padding">{this.$t('erp.b2c.ordertype_distribution',{defaultValue:'分销订单'})}</div>; break;
                            case 'brush': ordertype = <div class="b2ccolor-warning font-weight span-padding">{this.$t('erp.b2c.ordertype_brush',{defaultValue:'刷评订单'})}</div>; break;
                        }
                        return <div>{ordertype}</div>
                    }
                },
                {
					title: this.$t('erp.b2border.allcount',{defaultValue:'总金额'}),
                    key: 'amount',
                    width:80,
                },
                {
                    title: this.$t('global.common.status',{defaultValue:'状态'}),
                    width:90,
                    // key: 'orderStatus',
                    render: (h, { row }) => {
                        switch (row.orderStatus) {
                            case 'pending': return <vButton class="b2cspan-error span-padding">{this.$t('erp.b2c.orderstatus_pending',{defaultValue:'未支付'})}</vButton>; break;
                            case 'unshipped': return <vButton class="b2cspan-middle-content span-padding">{this.$t('erp.b2c.orderstatus_unshipped',{defaultValue:'未发货'})}</vButton>; break;
                            case 'approved': return <vButton class="b2cspan-success span-padding">{this.$t('erp.b2c.orderstatus_approved',{defaultValue:'已审核'})}</vButton>; break;
                            case 'assigned': return <vButton class="b2cspan-primary span-padding">{this.$t('erp.b2c.orderstatus_assigned',{defaultValue:'已分配'})}</vButton>; break;
                            case 'picked': return <vButton class="b2cspan-info span-padding">{this.$t('erp.b2c.orderstatus_picked',{defaultValue:'已配货'})}</vButton>; break;
                            case 'shipped': return <vButton class="b2cspan-light-content span-padding">{this.$t('erp.b2c.orderstatus_shipped',{defaultValue:'已发货'})}</vButton>; break;
                            case 'canceled': return <vButton class="b2cspan-warning span-padding">{this.$t('erp.b2c.orderstatus_canceled',{defaultValue:'已取消'})}</vButton>; break;
                            case 'refunded': return <vButton class="b2cspan-dark-primary span-padding">{this.$t('erp.b2c.orderstatus_refunded',{defaultValue:'已退款'})}</vButton>; break;
                        }

                    },
                },
                {
					title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
					// key: 'channelCreated',
					render:(h,{row})=>{
						let arr = row.channelCreated.split('T')
						let times = arr[1].split('+')
						return <div>{arr[0]} {times[0]}</div>
					}
				}
                ]
			}
		}
	},
}
</script>